import find from 'lodash/find';
import { FormattedMessage, injectIntl } from 'react-intl';

const InjectMassage = (props: any) => <FormattedMessage {...props} />;

export default injectIntl(InjectMassage, {
  forwardRef: false,
});

export const getKoreanName = (values: Array<any>, langCode = 'KO') => {
  if (!values || values.length === 0) return null;
  const koreanValue = find(values, (v) => v.langCode === langCode);
  return koreanValue ? koreanValue.name : values[0].name;
};

export const getIntlValue = (object: any, langCode = 'ko-kr', key = 'values') => {
  if (!object) return null;

  const keyList = Object.keys(object);

  if (keyList.length === 0) return null;

  const findLang = langCode.split('-')[0].toUpperCase();

  const findValue = object[findLang];

  if (findValue) return findValue[key];

  // 일치하는 언어가 없을 경우 0번째 index의 언어로 리턴
  return object[keyList[0]][key];
};
